import React from "react";
import { CustomAccordion } from "../../components/Accordion";
import { Box, Typography } from "@mui/material";

const TopicsAndQuestionsDetails = [
    {
        id: "1",
        summary: "Speech Topic 1",
        details: [
            {
                id: "1",
                heading: "Speech Topic",
                para: "The Future of AI in Business",
            },
            {
                id: "2",
                heading: "Description",
                para: "Exploring the impact of artificial intelligence on corporate strategies, automation, and decision-making in modern enterprises.",
            },
            {
                id: "3",
                heading: "Session Questions",
                list: [
                    "Q1. How can AI improve customer experience in e-commerce?",
                    "Q2. What are the ethical considerations of AI-driven decision-making?",
                    "Q3. Which industries will be most disrupted by AI in the next decade?",
                ],
            },
        ],
    },
    {
        id: "2",
        summary: "Speech Topic 2",
    },
];
function TopicsAndQuestions() {

    const DetailsUI = ({details}) => {
        return (
            <>
                {details?.map((cDetails) => (
                    <Box key={cDetails.id} marginBottom={'1rem'} marginLeft={'2rem'}>
                        <Typography fontSize={"14px"} fontWeight={700}>
                            {cDetails.heading}
                        </Typography>
                        {cDetails.para && (
                            <Typography fontSize={"15px"} fontWeight={400} color={"#575757"} marginTop={"0.25rem"}>
                                {cDetails.para}
                            </Typography>
                        )}
                        {cDetails?.list?.map((cListItem) => (
                            <Typography
                                component={"p"}
                                fontSize={"15px"}
                                fontWeight={400}
                                color={"#575757"}
                                marginTop={"0.4rem"}
                                sx={{
                                    borderRadius: "4px",
                                    background: "#F8F9FA",
                                    padding:'10px'
                                }}
                            >
                                {cListItem}
                            </Typography>
                        ))}
                    </Box>
                ))}
            </>
        );
    };
    return (
        <div>
            {TopicsAndQuestionsDetails.map((cItem) => (
                <CustomAccordion key={cItem.id} view="v1" gutterBottom summary={cItem.summary} details={<DetailsUI details={cItem.details} />}></CustomAccordion>
            ))}
        </div>
    );
}

export default TopicsAndQuestions;
